import styled from 'styled-components';
import { SpinnerMatchingStyled } from 'petco-ui/elements/spinner/matching-spinner/SpinnerMatching.styled';
import { themed } from '@/shared/ui/core';

export const SpinnerStyled = styled.div`
  ${SpinnerMatchingStyled} {
    margin: 1rem auto;
    width: 3rem;
    height: 3rem;

    svg {
      path {
        stroke: ${themed('primary.main')};
      }
    }
  }
`;
